import * as React from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'react-apollo'
import { History, Location } from 'history'
import {
  TabDivider,
  TabSelected,
  TabNormal,
  TabFill,
  TabDisabled
} from './Styles'
import { Dispatch } from 'redux'
import { setTabulationLock } from '../../actions/tabulation'
import { Store } from '../../reducers'
import { connect } from 'react-redux'
import { Action } from '../../actions/types'

export type tabType = {
  name: string
  hash: string
  // tslint:disable-next-line
  view: (...args) => React.ReactNode
}

type InputProps = {
  tabs: tabType[]
  payload?: object
  history: History
  location: Location
  setTabulationLock: (lock: boolean) => Action
  tabulationLocked: boolean
}

export class TabulationsNode extends React.Component<InputProps> {
  constructor(props: InputProps) {
    super(props)
  }

  findByName(name: string) {
    return this.props.tabs.find(val => val.name === name) || this.props.tabs[0]
  }

  findByHash(hash: string) {
    return this.props.tabs.find(val => val.hash === hash) || this.props.tabs[0]
  }

  getNames() {
    return this.props.tabs.map(val => val.name)
  }

  tabSelected = (tab: string) => {
    const { history, tabulationLocked } = this.props
    if (history && !tabulationLocked) {
      history.replace(this.findByName(tab).hash)
    }
  }

  lockTabs = (locked: boolean) => {
    this.props.setTabulationLock(locked)
  }

  render() {
    const { payload, tabs, tabulationLocked } = this.props
    const hash = location ? location.hash : tabs[0].hash
    const selected = this.findByHash(hash).name

    return (
      <div>
        <TabDivider id="tabDivider">
          {this.getNames().map((tabName, indx) => {
            const disabled = tabulationLocked && tabName !== selected
            const tabElem =
              tabName === selected ? (
                <TabSelected onClick={() => this.tabSelected(tabName)}>
                  {tabName}
                </TabSelected>
              ) : disabled ? (
                <TabDisabled>{tabName}</TabDisabled>
              ) : (
                <TabNormal onClick={() => this.tabSelected(tabName)}>
                  {tabName}
                </TabNormal>
              )
            return (
              <span key={indx}>
                {tabElem}
                <TabFill>&nbsp;</TabFill>
              </span>
            )
          })}
        </TabDivider>
        {payload && this.findByName(selected).view(payload)}
      </div>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  tabulationLocked: state.tabulation.locked
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  setTabulationLock: lock => dispatch(setTabulationLock(lock))
})

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(TabulationsNode)



// WEBPACK FOOTER //
// ./src/Components/Projects/Tabulations.tsx